import {Text} from '@chakra-ui/react';
import {useCartContext} from 'components/providers';
import {AlertDialog} from 'components/shared';
import {useTranslation} from 'hooks';
import {FC} from 'react';

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm?: () => void;
  providerName?: string;
}

export const AlertClearCart: FC<IProps> = ({isOpen, onClose, onConfirm, providerName}) => {
  const {clearCart} = useCartContext();
  const {t} = useTranslation();
  const title = t('ADDING_PRODUCT_FROM_ANOTHER_RESTAURANT_TITLE');

  const handleConfirm = () => {
    clearCart();
    onConfirm && onConfirm();
    onClose();
  };

  return (
    <AlertDialog
      title={title}
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={handleConfirm}
      cancelButtonValue={t('LEAVE_PRODUCTS')}
      successButtonValue={t('CLEAR_TO_CART')}
    >
      {t('CLEAR_TO_CART_DESCRIPTION_PART1')} <strong>{providerName}.</strong>{' '}
      <Text fontWeight={400}>{t('CLEAR_TO_CART_DESCRIPTION_PART2')}</Text>
    </AlertDialog>
  );
};
